// extracted by mini-css-extract-plugin
module.exports = {"practiceProblemEditor":"PracticeProblemEditor_practiceProblemEditor__Ldb0t"};